import {
  CategoriaCardapio,
  CriarSolicitacaoDto,
  SolicitacaoDeliveryResponse,
  UnidadeDeliveryLista,
  UnidadeDeliveryPublico,
} from '../delivery.types';
import ServiceAPI from './serviceapi';

const PATH = '/delivery-publico';

export const DeliveryService = {
  /** Lista unidades ativas (leve — sem logo nem configuração visual). */
  listarUnidades: () =>
    ServiceAPI.get<UnidadeDeliveryLista[]>(`${PATH}/unidades`),

  /** Busca unidade completa (logo, tema, tiposTitulo) após seleção. */
  buscarUnidade: (chave: string) =>
    ServiceAPI.get<UnidadeDeliveryPublico>(`${PATH}/unidade`, { params: { chave } }),

  buscarCatalogo: (codigoUnidade: number) =>
    ServiceAPI.get<CategoriaCardapio[]>(`${PATH}/catalogo`, { params: { codigoUnidade } }),

  criarSolicitacao: (dto: CriarSolicitacaoDto) =>
    ServiceAPI.post<SolicitacaoDeliveryResponse>(`${PATH}/solicitacao`, dto),

  buscarStatusSolicitacao: (codigo: number) =>
    ServiceAPI.get<SolicitacaoDeliveryResponse>(`${PATH}/solicitacao/status`, { params: { codigo } }),
};
